import * as React from 'react'
import { faClose, FaIcon } from '@/lib/fa'
import EditGroupDetailsModal from './EditGroupDetailsModal'
import ModalLayout from '../shared/ModalLayout'
import EditGroupsCustomList from './edit/EditGroupCustomList'
import EditGroupsDefaultList from './edit/EditGroupDefaultList'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const EditGroupModal = ({ close, groups, companyId }) => {
  const { t } = useLocalize()
  const [isAddGroupModelOpen, setIsAddGroupModelOpen] = React.useState(false)
  const [selectedGroup, setSelectedGroup] = React.useState(null)
  const isDefaultGroup = selectedGroup && selectedGroup.id < 0
  React.useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])
  React.useEffect(() => {
    if (selectedGroup) {
      setIsAddGroupModelOpen(true)
    }
  }, [selectedGroup])

  React.useEffect(() => {
    // Update selectedGroup when groups change
    if (selectedGroup && groups) {
      const updatedGroup = groups.find((g) => g.id === selectedGroup.id)
      if (
        updatedGroup &&
        JSON.stringify(updatedGroup) !== JSON.stringify(selectedGroup)
      ) {
        setSelectedGroup(updatedGroup)
      }
    }
  }, [groups])

  return (
    <ModalLayout>
      <div className="tw-flex tw-max-h-[500px] tw-w-full tw-max-w-[500px] tw-flex-col tw-justify-between tw-rounded-lg tw-bg-white">
        <div className="tw-flex tw-items-center tw-justify-between tw-p-4">
          <div className="tw-flex tw-flex-col tw-gap-2">
            <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
              {t('driverModule.edit-groups')}
            </p>
            <p className="tw-text-sm tw-text-content-base/80">
              {t('driverModule.select-group-to-edit')}
            </p>
          </div>
          <FaIcon
            icon={faClose}
            className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>
        <div className="tw-overflow-auto tw-pt-0">
          <>
            <EditGroupsDefaultList setSelectedGroup={setSelectedGroup} />
            <EditGroupsCustomList
              groups={groups}
              setSelectedGroup={setSelectedGroup}
            />
          </>
        </div>
      </div>
      {isAddGroupModelOpen && selectedGroup && (
        <EditGroupDetailsModal
          companyId={companyId}
          group={selectedGroup}
          isDefaultGroup={isDefaultGroup}
          close={() => setIsAddGroupModelOpen(false)}
        />
      )}
    </ModalLayout>
  )
}
export default EditGroupModal
